import { getAssetsUrl } from 'helpers/getAssetsUrl'

export const ON_BOARDING_BRIEF_QUIZ_CONTENT = {
  src: getAssetsUrl('organizations/b21d937a-c908-43fe-bb1b-c799ba72dca4.png'),
  philosofText:
    'Knowledge does not mean mastering a great quantity of different information, but understanding the nature of mind This knowledge can penetrate each one of our thoughts and illuminate each one of our perceptions',
  philosofName: '- Matthieu Ricard',
}
